import { createAsyncThunk } from "@reduxjs/toolkit";
import { readContract } from "@wagmi/core";
import { Address } from "viem";

import { walletConfig } from "services/wallet";
import { IStakingAmount } from "shared/interfaces/staking";
import { displayAmount } from "shared/utils/displayAmount";
import type { ThunkApiConfig } from "store";
import { stakingConfig } from "store/config";

export const getReward = createAsyncThunk<IStakingAmount, { address: Address }, ThunkApiConfig>(
  "staking/getReward",
  async ({ address }, { getState, rejectWithValue, fulfillWithValue }) => {
    try {
      const state = getState();
      const tokenAddress = state.staking.stakingFieldsData?.token;
      const reward = await readContract(walletConfig, {
        ...stakingConfig,
        functionName: "getReward",
        args: [address],
      });
      if (tokenAddress) {
        const tokenDecimals = state.tokens?.[tokenAddress].decimals;
        return fulfillWithValue({ value: reward, formatted: displayAmount(reward.toString(), tokenDecimals) });
      } else {
        return fulfillWithValue({ value: reward, formatted: "0" });
      }
    } catch (e) {
      console.error(`Error getting reward: \n ${e}`);
      return rejectWithValue(null);
    }
  },
);
